
export const passwordPattern = '^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*(?=.*[@#$!%^&*+=.])).{10,}$';

// Need to change pattern on these two script if change above 
// website/scripts/users/passwordPattern
